import * as Yup from 'yup';

export const validationScheme = Yup.object().shape({
  allowPaymentViaCC: Yup.boolean().when('allowPaymentViaACH', {
    is: false,
    then: Yup.boolean().oneOf(
      [true],
      'You should select at least one payment method.',
    ),
  }),
  allowPaymentViaACH: Yup.boolean(),
  absorbTransactionFees: Yup.boolean(),
  defaultMemo: Yup.string(),
});
